module.exports = __webpack_public_path__ + "static/media/errorImage.285b3398.svg";